export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Core/Components/DBConnectionAdminConsoleComponent.vue'),
    contentData: {
        key: 'ConnectionStringAdminConsole',
        visible: true
    }
};